import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth, fetchProfile } from '../redux/slices/authSlice';
import { PAGE_PERMISSIONS, hasAnyPermission } from '../utils/permissions';
import { api } from '../redux/api/axiosManager';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, loading, user, error } = useSelector((state) => state.auth);
  const [authChecked, setAuthChecked] = useState(false);
  const profileFetchedRef = useRef(false);

  useEffect(() => {
    // Token kontrolü yap (sadece bir kez)
    if (!authChecked) {
      dispatch(checkAuth());
      setAuthChecked(true);
    }
    
    // User yoksa ama authenticated ise profile çek
    if (!user && !loading && isAuthenticated && !profileFetchedRef.current) {
      // Profile fetch edilmemişse veya hata varsa tekrar dene
      profileFetchedRef.current = true;
      dispatch(fetchProfile()).catch((err) => {
        // 500 hatası geldiğinde tekrar deneme (max 3 kez)
        const errorStatus = err?.response?.status || err?.status;
        if (errorStatus === 500) {
          console.warn('⚠️ Profile fetch 500 hatası, 5 saniye sonra tekrar denenecek');
          setTimeout(() => {
            profileFetchedRef.current = false; // Tekrar deneme için reset
          }, 5000);
        } else {
          // 500 dışı hatalar için de reset (ama daha uzun süre bekle)
          setTimeout(() => {
            profileFetchedRef.current = false;
          }, 10000);
        }
      });
    }
  }, [dispatch, user, loading, isAuthenticated, error, authChecked]);


  const [loadingTimeout, setLoadingTimeout] = useState(false);
  
  useEffect(() => {
    if (loading && !loadingTimeout) {
      const timeout = setTimeout(() => {
        setLoadingTimeout(true);
        console.warn('⚠️ Auth loading çok uzun sürdü, timeout yapılıyor');
      }, 5000); // 5 saniye sonra timeout
      
      return () => clearTimeout(timeout);
    } else if (!loading) {
      setLoadingTimeout(false);
    }
  }, [loading, loadingTimeout]);

  if (!authChecked || (loading && !loadingTimeout)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <svg className="animate-spin h-12 w-12 text-blue-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-3 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Giriş yapılmamışsa login sayfasına yönlendir (mevcut URL'i state olarak gönder)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;

